module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['active-filters', {
      disabled: _vm.disabled
    }]
  }, [_c('div', {
    staticClass: "active-filters__wrapper"
  }, _vm._l((_vm.activeFilters), function(filter, index) {
    return _c('div', {
      staticClass: "active-filters__item",
      on: {
        "click": function($event) {
          return _vm.removeFilter(index)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.renderItemText(filter)) + " "), _c('i', {
      staticClass: "fa fa-times active-filters__item-icon",
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af92a422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusables/ActiveFilters.vue
// module id = 1734
// module chunks = 1